import { DateTimeValueSchemas } from "@validereinc/utilities";
import { z } from "zod";
import {
  createExportListRequestSchema,
  createGetListRequestSchema,
} from "../util/index.ts";
import { AssetTypeSchema } from "./AssetSchemas.ts";
import { FlowProductTypes } from "./FlowSchemas.ts";

export const RecordGetListRequestSchema = createGetListRequestSchema(
  z
    .object({
      asset_id: z.string().uuid(),
      asset_type: AssetTypeSchema,
      reporting_group_id: z.string().uuid(),
      measurement_type: z.string(),
      year_month: DateTimeValueSchemas.dateYearMonth,
      "flow.id": z.string().uuid(),
      "flow.name": z.string(),
      "flow.type": z.string(),
      "flow.product_type": z.nativeEnum(FlowProductTypes),
      "flow.product_category": z.nativeEnum(FlowProductTypes),
    })
    .partial(),
  z
    .object({
      includeAssetDetail: z
        .boolean()
        .describe(
          "Set to true to include asset details in the response when grouping by {asset type}.id"
        ),
    })
    .partial()
);
export type RecordGetListRequestType = z.infer<
  typeof RecordGetListRequestSchema
>;

export const RecordExportListRequestSchema = createExportListRequestSchema(
  RecordGetListRequestSchema.shape.filters.unwrap()
);
export type RecordExportListRequestType = z.infer<
  typeof RecordExportListRequestSchema
>;
